export default "__VITE_ASSET__BrSmqkNc__"